module.exports = __webpack_public_path__ + "img/logo.bb7f1614.svg";